import React from 'react';
import {List, ListItem, ListItemSecondaryAction, ListItemText, makeStyles, useMediaQuery} from "@material-ui/core";
import {selectActivePatient, setCabinetActiveTab, setClient} from "@cabinet-packages/redux";
import {logout} from "@cabinet-packages/api";
import {AccessKey} from "@cabinet-packages/helpers";
import {setActiveStep} from "@cabinet-packages/redux/moduleReducers/wizardStepperReducer/serviceMidleware";
import {ConfirmDialogMedis, CustomDialog} from "@cabinet-packages/components";
import {useDispatch, useSelector} from "react-redux";
import exitImg from "@cabinet-packages/pages/WizardWrapper/components/Header/img/exit.png"
import ArrowForwardIcon from "@material-ui/icons/ArrowForwardIos";
import SettingsIcon from "@material-ui/icons/Settings";
import HelpIcon from "@material-ui/icons/Help";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import Typography from "@material-ui/core/Typography";
import {useHistory} from "react-router";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
    listPatientsContainer: {
        maxHeight: 200,
        overflowY: 'scroll',
        '&::-webkit-scrollbar': {
            // width: '2px'
            display: 'none'
        },
    },
    option: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '60px',
        cursor: 'pointer',
        '& > svg': {
            transition: '0.2s',
            color: 'grey'
        },
        '&:hover': {
            backgroundColor: '#EAEBED',
            '& > svg':{
                transform: 'scale(1.1)',
                color: 'black'
            }
        }
    },
    exitOption: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '50px',
        transition: '0.5s',
        cursor: 'pointer',
        borderRadius: '0 0 10px 10px',
        '&:hover': {
            background: theme.palette.colors.secondary,
            color: 'green'
        }
    },
    exitIcon: {
        opacity: '50%',
        height: 20,
        width: 25,
        background: `url(${exitImg})`,
        marginRight: 10,
    },
    optionText: {
        fontSize: '15px',
        fontWeight: 500,
        width: 'max-content'
    },
    arrowIcon: {
        position: 'absolute',
        right: '5px',
        fontSize: '15px'
    },
    item: {
        paddingLeft: '10px'
    },
    primaryText: {
        fontSize: '14px'
    },
    secondaryText: {
        fontSize: '12px'
    },
    selectedItem: {
        backgroundColor: '#d6fff9 !important',
        borderRight: `3px ${theme.palette.primary.main} solid`,
        '& svg' : {
            color: '#2cb8ad'
        }
    },
    addLabel: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.palette.primary.cell,
        textAlign: 'center',
        transition: '0.5s',
        height: '50px',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
            color: 'white',

            '& p': {
                color: 'white'
            }
        },
        '& p': {
            color: theme.palette.primary.main
        }
    },
    addPatient: {
        color: theme.palette.primary.main,
    }
}));

const items = [
    // {
    //     path: '/settings',
    //     pathName: 'settings',
    //     label: 'Налаштування та конфіденційність',
    //     icon: () => <SettingsIcon />
    // },
    // {
    //     path: '/info/questions',
    //     pathName: 'info',
    //     label: 'Довідка та підтримка',
    //     icon: () => <HelpIcon />
    // }
]

function SidePanelMenu() {
    const classes = useStyles()
    const dispatch = useDispatch()
    const history = useHistory()
    const path = window.location.pathname.split('/').at(1)
    const idFromPathname = +history.location.pathname.split('/').pop();
    const {activePatient, listOfPatients} = useSelector(state => state.patients);
    const {themeMaterialUI} = useSelector(store => store.theme);
    const mdUp = useMediaQuery(theme => theme.breakpoints.up('md'))

    const handleSelectPatient = (e, el) => {
        if(history.location.pathname.includes("patient-card") || history.location.pathname.includes("info")){
            history.push(`/patient-card/${el.id}`)
            dispatch(setCabinetActiveTab('/patient-card'))
        }
        history.push(`/patient-card/${el.id}`)

        dispatch(selectActivePatient(listOfPatients.find(patient => patient.id === el.id)));
    }

    const handleOptionClick = (e, label, path) => {
        dispatch(setCabinetActiveTab(path))
        history.push(path)
    };

    const handleClickOnExitButton = (event) => {
        event.stopPropagation();
        event.preventDefault();
        CustomDialog(ConfirmDialogMedis,
            {
                text: 'Ви впевнені, що хочете вийти?',
                onConfirm: async () => {
                    dispatch(setClient(null));
                    await logout();
                    localStorage.removeItem('activePatient');
                    localStorage.removeItem('activePatientPhone');
                    AccessKey.remove();

                    dispatch(setActiveStep(3));
                    dispatch(setActiveStep(3));
                    dispatch(setActiveStep(3));
                    dispatch(setActiveStep(3));

                    history.push('/auth')
                }
            }, false, themeMaterialUI);
    }

    const handleClickOnRegisterNewPatient = (event) => {
        dispatch(setCabinetActiveTab("/patient-card"))
        history.push('/add-new-patient');
    };

    return (
        <List
            dense
            disablePadding
            style={{width: '100%', display: 'flex', flexDirection: 'column', flexGrow: 1}}
        >
            <div className={classes.listPatientsContainer}>
                {listOfPatients && listOfPatients.map((el, id) => (
                    <span className='authItem' key={el.id}>
                    <ListItem key={id} selected={el.id === activePatient.id} button onClick={(e) => handleSelectPatient(e, el)}
                              classes={{selected: classes.selectedItem}}
                              className={classes.option}>
                    <ListItemText
                        primary={el.lastname + " " + el.firstname}
                        secondary={el.main ? "Ваш кабінет" : moment(el.birthday, 'YYYY-MM-DD').format('DD-MM-YYYY')}
                        classes={{primary: classes.primaryText, secondary: classes.secondaryText}}
                        className={classes.item}
                    />
                     <ListItemSecondaryAction>
                        <ArrowForwardIcon style={{fontSize: '12px', color: idFromPathname === el.id? '#2cb8ad' : 'inherit'}}/>
                    </ListItemSecondaryAction>
                </ListItem>
                </span>
                ))}
            </div>

            <div style={{flexGrow: mdUp ? 1 : 0}}>
                <ListItem className={classes.addLabel} onClick={event => handleClickOnRegisterNewPatient(event)}>
                    <Typography>
                        + додати пацієнта
                    </Typography>
                </ListItem>
            </div>


            {items.map((item, id) => (
                <ListItem key={id} selected={item.pathName === path} button onClick={event => handleOptionClick(event, item.label, item.path)} classes={{selected: classes.selectedItem}} className={classes.option}>
                    <item.icon/>
                    <ListItemText
                        primary={item.label}
                        classes={{primary: classes.primaryText, secondary: classes.secondaryText}}
                        className={classes.item}
                    />
                    <ListItemSecondaryAction>
                        <ArrowForwardIcon style={{fontSize: '12px', color: 'inherit'}}/>
                    </ListItemSecondaryAction>
                </ListItem>
            ))}

            <ListItem button onClick={(e) => handleClickOnExitButton(e)} className={classes.exitOption}>
                <ExitToAppIcon/>
                <Typography className={classes.optionText}>
                    Вихід
                </Typography>
            </ListItem>

        </List>
    );
}

export default SidePanelMenu;